import { apiClient, type SyadateContractExEntity } from '@/libs/api'

export type FetchSyadateContractQuery = {
  tenantKey: string
  contractId: number
}

export const fetchSyadateContract = async (
  { tenantKey, contractId }: FetchSyadateContractQuery,
  signal?: AbortSignal
): Promise<SyadateContractExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .syadate_contracts._id(contractId)
    .$get({
      config: { signal }
    })
  return data
}
